import { useEffect } from "react";
import { useFetchTechinicalHistory } from "@/hooks/techinicals-history/queries/useFetchTechinicalHistory";
import { DocumentCard } from "./DocumentCard";
import { TechinicalOutputDTO } from "@/features/techinicaldocument/types";

interface TechnicalCardProps {
  technical: TechinicalOutputDTO;
  index: number;
  clientId?: string;
  onSelect: (technical: TechinicalOutputDTO) => void;
}

export function TechnicalCard({
  technical,
  index,
  clientId,
  onSelect,
}: TechnicalCardProps) {
  const { fetchAll, items, loading } = useFetchTechinicalHistory();

  useEffect(() => {
    if (clientId && technical._id) {
      fetchAll({ techinicalId: technical._id, clientId });
    }
  }, [clientId, technical._id, fetchAll]);

  const hasHistory = items.length > 0;
  const lastHistory = items[0];

  return (
    <DocumentCard
      doc={technical}
      index={index}
      filledDoc={
        hasHistory
          ? {
              path: "generated", // Dummy path to trigger "filled" style (blue)
              createdAt: lastHistory.createdAt,
            }
          : undefined
      }
      isLoading={loading}
      onDownload={() => onSelect(technical)}
      forceAllowAction={true}
    />
  );
}
